import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createBlock as _createBlock, Fragment as _Fragment, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0445a7e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "header-title flex items-center gap-2" }, "Message Support", -1))
const _hoisted_4 = { class: "property" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label",
  for: "type"
}, "Type", -1))
const _hoisted_6 = { class: "flex gap-x-2" }
const _hoisted_7 = {
  key: 0,
  class: "input-error"
}
const _hoisted_8 = { class: "property" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label",
  for: "email"
}, [
  /*#__PURE__*/_createTextVNode(" Email "),
  /*#__PURE__*/_createElementVNode("small", { class: "text-gray-500 font-normal" }, "(Optional)")
], -1))
const _hoisted_10 = {
  key: 0,
  class: "input-error"
}
const _hoisted_11 = { class: "property" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label",
  for: "description"
}, "Description", -1))
const _hoisted_13 = {
  key: 0,
  class: "input-error"
}
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "flex align-center gap-x-1.5" }

import { weatherLocation } from '@/states/homeState';
import { computed, ref } from 'vue';
import { useForm, useField } from 'vee-validate';
import { object, string } from 'yup';
import { createShareLink } from '@/utils/methods/share-link';
import { postReport } from '@/services/notion.services';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportModal',
  props: {
    draw: null
  },
  setup(__props: any) {

const props = __props as { draw: MapboxDraw }


const successSnackbar = ref(false);
const dialog = ref(false);
const { handleSubmit, values, errors, isSubmitting, resetForm } = useForm({
  initialValues: { email: '', description: '', type: 'Report' },
  validationSchema: object({
    email: string().trim().email('Invalid email'),
    type: string().trim().oneOf(['Report', 'Request']).required(),
    description: string()
      .trim()
      .max(500, 'Only 500 characters are allowed')
      .required('Description is required'),
  }),
});

const type = useField('type');
const email = useField('email');
const description = useField('description');

const isEmailInvalid = computed(() => errors.value.email && email.meta.touched);
const isDescriptionInvalid = computed(() => errors.value.description && description.meta.touched);

const onSubmit = handleSubmit(async (values) => {
  try {
    await postReport({
      location: weatherLocation.value.join(','),
      description: values.description,
      link: createShareLink(props.draw, weatherLocation.value),
      type: values.type,
      ...(email && { email: values.email }),
    });
    resetForm();
    successSnackbar.value = true;
    dialog.value = false;
  } catch (error) {
    console.error(error);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_VSnackbar = _resolveComponent("VSnackbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_dialog, {
      modelValue: dialog.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((dialog).value = $event)),
      location: "center center",
      "scroll-strategy": "none",
      "content-class": "align-center"
    }, {
      activator: _withCtx(({ props }) => [
        _renderSlot(_ctx.$slots, "default", { modalProp: props })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (dialog.value = false)),
              class: "close-btn"
            }, [
              _createVNode(_component_Icon, { icon: "mdi:close" })
            ])
          ]),
          _createElementVNode("form", {
            class: "body",
            onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("label", {
                  class: _normalizeClass(["radio-opt", { selected: _unref(values).type === 'Report' }])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    name: "type",
                    id: "type",
                    value: "Report",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(values).type) = $event)),
                    class: _normalizeClass({ error: _unref(isEmailInvalid) })
                  }, null, 2), [
                    [_vModelRadio, _unref(values).type]
                  ]),
                  _createTextVNode(" Report Issue ")
                ], 2),
                _createElementVNode("label", {
                  class: _normalizeClass(["radio-opt", { selected: _unref(values).type === 'Request' }])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    name: "type",
                    id: "type",
                    value: "Request",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(values).type) = $event)),
                    class: _normalizeClass({ error: _unref(isEmailInvalid) })
                  }, null, 2), [
                    [_vModelRadio, _unref(values).type]
                  ]),
                  _createTextVNode(" Request Feature ")
                ], 2)
              ]),
              (_unref(errors).email && _unref(type).meta.touched)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(errors).type), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _withDirectives(_createElementVNode("input", {
                type: "email",
                name: "email",
                id: "email",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(values).email) = $event)),
                placeholder: "your_email@example.com",
                class: _normalizeClass({ error: _unref(isEmailInvalid) })
              }, null, 2), [
                [_vModelText, _unref(values).email]
              ]),
              (_unref(errors).email && _unref(email).meta.touched)
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_unref(errors).email), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _withDirectives(_createElementVNode("textarea", {
                name: "description",
                id: "description",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(values).description) = $event)),
                rows: "10",
                class: _normalizeClass({ error: _unref(isDescriptionInvalid) }),
                placeholder: "Describe issue or Request a feature"
              }, null, 2), [
                [_vModelText, _unref(values).description]
              ]),
              (_unref(errors).description && _unref(description).meta.touched)
                ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_unref(errors).description), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", { disabled: _unref(isSubmitting) }, [
              (_unref(isSubmitting))
                ? (_openBlock(), _createBlock(_component_Icon, {
                    key: 0,
                    class: "loading-icon",
                    icon: "mdi:loading"
                  }))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("Submit")
                  ], 64))
            ], 8, _hoisted_14)
          ], 32)
        ])
      ]),
      _: 3
    }, 8, ["modelValue"]),
    _createVNode(_component_VSnackbar, {
      location: "top center",
      class: "sucess",
      modelValue: successSnackbar.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((successSnackbar).value = $event))
    }, {
      actions: _withCtx(() => [
        _createElementVNode("button", {
          class: "v-snackbar-close-btn",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (successSnackbar.value = false))
        }, [
          _createVNode(_component_Icon, { icon: "mdi:close" })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_15, [
          _createVNode(_component_Icon, {
            icon: "mdi:check",
            class: "inline"
          }),
          _createTextVNode(" Successfly submitted. ")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})